enum UserActions {
  SET_USER_LOADING = 'SET_USER_LOADING',
  GET_USER = 'GET_USER',
  GET_USER_SUCCESS = 'GET_USER_SUCCESS',
  SET_TOKEN = 'SET_TOKEN',
}

export default UserActions;
